import React from "react";
import Button from "@mui/material/Button";
import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import DialogContentText from "@mui/material/DialogContentText";
import {deleteRole, setSelectedRole} from "../../index";
import {setModal} from "../../../../Common/App";
import {DialogCard} from "../../../../../Components";
import {CardActions, CardContent, CardHeader, Alert} from "@mui/material";
import {Loader} from "../../../../../Components";


export const RoleDeleteModal = () => {

    const dispatch = useDispatch();
    const selectedRole = useSelector((store)=> store.roles.selected);
    // Store role info in local state to prevent loss if Redux state changes
    const [item] = useState(selectedRole);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("info");

    const handleSubmit = async () => {
        if (!item || !item.id) {
            setMessage('Role information is missing. Please close and try again.');
            setStatus('error');
            return;
        }

        setIsLoading(true);
        setMessage('');
        await deleteRole({dispatch, filters:{id : item.id}}).then((res) => {
            if(res.success){
                dispatch(setSelectedRole(item.id))
                dispatch(setModal({component:null, open:false}));
            }
            setIsLoading(false);
            setMessage(res.message || '');
            setStatus(res.status || 'error');
        });
    };

    return(
        <DialogCard>
            <CardHeader
                title={"Delete Role"}
                avatar={<Loader isLoading={isLoading} type={"linear"}/>}
            />
            <CardContent sx={{ p: 2, pt:2 }}>
                <DialogContentText sx={{ mb: 2 }}>
                    Are you sure, you want to remove this role?
                </DialogContentText>
                {message && (
                    <Alert severity={status === 'error' ? 'error' : 'info'} sx={{ mt: 2 }}>
                        {message}
                    </Alert>
                )}
            </CardContent>
            <CardActions>
                <Button variant={"outlined"} onClick={() => dispatch(setModal({component:null, open:false}))}>Cancel</Button>
                <Button disabled={isLoading} variant="contained" color={'error'} onClick={ handleSubmit }>Delete Role</Button>
            </CardActions>
        </DialogCard>
    )
}